import React from "react";

export function ArrowRight(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="10"
            viewBox="0 0 16 10"
            fill="none"
            {...props}
        >
            <path
                d="M13.834 4.99976L1.33398 4.99976"
                stroke="#002564"
                strokeWidth="1.25"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M10.5 0.833252L14.0774 4.41066C14.3552 4.68844 14.4941 4.82733 14.4941 4.99992C14.4941 5.17251 14.3552 5.3114 14.0774 5.58917L10.5 9.16659"
                stroke="#002564"
                strokeWidth="1.25"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}


